module.exports = __webpack_public_path__ + "static/media/tools-question2.15ce9110.svg";